import { render, staticRenderFns } from "./SuggestionListInfo.vue?vue&type=template&id=5eb026a0&scoped=true&"
import script from "./SuggestionListInfo.vue?vue&type=script&lang=js&"
export * from "./SuggestionListInfo.vue?vue&type=script&lang=js&"
import style0 from "./SuggestionListInfo.vue?vue&type=style&index=0&id=5eb026a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb026a0",
  null
  
)

export default component.exports